export var getSpacingDirectionFromImagePosition = function(imagePosition) {
    if (imagePosition === "top" || imagePosition === "bottom") {
        return imagePosition;
    }
    return undefined;
};
